import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import { FORM_SELECT_BUTTON_CLASS_NAME, FORM_SELECT_MENU_CLASS_NAME } from '../../theme/constants/select';
import SelectButton from '../buttons/SelectButton';

const filterOptions = {
  FACTORING: [
    {
      label: 'Todos',
      value: 'ALL',
      key: 'everyInvoice-filter',
      filter: {
        hasRejectedPreoffer: false,
      },
    },
    {
      label: 'Disponibles',
      value: 'AVAILABLE',
      key: 'availableForFinancing-filter',
      filter: {
        availableForFinancing: 'AVAILABLE',
        hasRejectedPreoffer: false,
      },
    },
    {
      label: 'Rechazadas',
      value: 'REJECTED',
      key: 'hasRejectedPreoffer-filter',
      filter: {
        hasRejectedPreoffer: true,
      },
    },
    {
      label: 'En evaluación',
      value: 'EVALUATING',
      key: 'hasEvaluatingPreoffer-filter',
      filter: {
        hasEvaluatingPreoffer: true,
        hasRejectedPreoffer: false,
      },
    },
  ],
  ORDERING: [
    {
      label: 'Todos',
      value: 'ALL',
      key: 'everyInvoice-filter',
      filter: {
      },
    },
    {
      label: 'Disponibles',
      value: 'AVAILABLE',
      key: 'availableForFinancing-filter',
      filter: {
        status: ['Simulation'],
      },
    },
    {
      label: 'Rechazadas',
      value: 'REJECTED',
      key: 'hasRejectedPreoffer-filter',
      filter: {
        status: ['Rejected'],
      },
    },
    {
      label: 'En evaluación',
      value: 'EVALUATING',
      key: 'hasEvaluatingPreoffer-filter',
      filter: {
        status: ['Evaluation'],
      },
    },
  ],
};

const FingoPreOfferFilter = ({ states, setStates, filterType, label, ...props }) => {
  const [selectedFilter, setSelectedFilter] = useState(filterOptions[filterType][0].value);
  const { availableForFinancing, hasRejectedPreoffer, hasEvaluatingPreoffer, ...rest } = states;
  const setPreOfferFiltersEffect = (e) => {
    setSelectedFilter(e.target.value);
    setStates(
      { ...rest,
        ...filterOptions[filterType].find(
          (el) => el.value === e.target.value,
        ).filter,
      },
    );
  };

  const renderValue = (selected) => {
    const option = filterOptions[filterType].find((filter) => filter.value === selected);
    return `${label}: ${option?.label ?? 'Todos'}`;
  };

  return (
    <SelectButton
      value={selectedFilter}
      onChange={setPreOfferFiltersEffect}
      className={FORM_SELECT_BUTTON_CLASS_NAME}
      MenuProps={{ PaperProps: { className: FORM_SELECT_MENU_CLASS_NAME } }}
      renderValue={renderValue}
      SelectDisplayProps={{ style: { paddingRight: 30 } }}
      {...props}
    >
      {filterOptions[filterType].map((filter) => (
        <MenuItem
          key={filter.key}
          value={filter.value}
        >
          {filter.label}
        </MenuItem>
      ))}
    </SelectButton>
  );
};

FingoPreOfferFilter.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  states: PropTypes.object.isRequired,
  filterType: PropTypes.oneOf(['ORDERING', 'FACTORING']).isRequired,
  setStates: PropTypes.func.isRequired,
  label: PropTypes.string,
};

FingoPreOfferFilter.defaultProps = {
  label: 'Estado',
};

export default FingoPreOfferFilter;
